<template>
  <v-layout row align-content-space-between align-center class="shift-item">
    <v-flex>
      <v-layout row align-content-start align-center>
        <v-flex class="shift-details">
          <div>
            <span class="title">{{ itemData.startDatetime | moment("dddd, MMMM D") }}</span>
          </div>
          <div>
            <span class="all-caps font-weight-bold title">{{ itemData.location }}</span>
          </div>
          <div>
            <span class="title subtle">
              {{ itemData.shiftRole }} |
              {{ itemData.startDatetime | moment("h:mm a") }} -
              {{ itemData.endDatetime | moment("h:mm a") }}
            </span>
          </div>
          <div>
            <span class="all-caps title subtle">
              {{ itemData.workerName }}
            </span>
          </div>
          <div>
            <v-layout row>
              <v-flex>
                <BonusView :shift="itemData" type="travel" :role="user.role" />
                <BonusView :shift="itemData" type="callIn" :role="user.role" />
                <BonusView :shift="itemData" type="straight" :role="user.role" />
              </v-flex>
            </v-layout>
          </div>
            <div class="unstyled subtle">
              <BonusList :shift="itemData" :role="user.role" />
            </div>
          </div>
        </v-flex>
      </v-layout>
    </v-flex>

  </v-layout>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    showIcon: Boolean,
    smaller: Boolean,
    pickupable: Boolean,
    wide: Boolean,
    itemData: Object
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
  },
  methods: {
    pickUp () {
      this.apiCallPending = true
      this.$store.dispatch('shifts/pickUp', this.itemData).finally(res => {
        this.apiCallPending = false
        this.pickUpDialog = false
      })
    },
  },
  data: function () {
    return {
      pickUpDialog: false,
      apiCallPending: false
    }
  },
}
</script>

<style scoped>
.icon {
  display: inline-block;
}
.shift-details-icon {
  cursor: default;
}

.shift-details {
  display: inline-block;
}

.smaller {
  font-size: 0.8em;
}

.smaller-icon {
  font-size: 0.9em;
}
</style>
